import type { AudioTrack, ProjectMode, TrackKind } from '../api/types'

export const TRACK_KINDS: readonly TrackKind[] = ['me', 'dialogue', 'full', 'unknown']

export const TRACK_KIND_LABELS: Record<TrackKind, string> = {
  me: 'M&E — музыка и эффекты',
  dialogue: 'Реплики (оригинал)',
  full: 'Полная дорожка',
  unknown: 'Не определена',
}

export const TRACK_KIND_SHORT: Record<TrackKind, string> = {
  me: 'M&E',
  dialogue: 'реплики',
  full: 'полная',
  unknown: '?',
}

export const PROJECT_MODES: readonly ProjectMode[] = ['mute', 'replace']

export const MODE_LABELS: Record<ProjectMode, string> = {
  mute: 'Глушение оригинала',
  replace: 'Замена на M&E',
  overlay: 'ML-разделение (позже)',
}

export const MODE_HINTS: Record<ProjectMode, string> = {
  mute: 'Основа — звук видео, приглушённый до заданной громкости. Так работает MVP.',
  replace:
    'Основа — дорожка M&E: музыка и эффекты идут непрерывно, оригинальные реплики не участвуют совсем.',
  overlay: 'Разделение оригинала на голос и фон средствами ML. Ещё не реализовано.',
}

/** Режимы, которые умеет рендерить сервер. `overlay` — задел на будущее. */
export function isRenderMode(value: string): value is 'mute' | 'replace' {
  return value === 'mute' || value === 'replace'
}

export function isTrackKind(value: string): value is TrackKind {
  return (TRACK_KINDS as readonly string[]).includes(value)
}

export function findTrackByKind(tracks: AudioTrack[], kind: TrackKind): AudioTrack | null {
  return tracks.find((track) => track.kind === kind) ?? null
}

/** Человекочитаемое имя дорожки для селектов и списков. */
export function trackTitle(track: AudioTrack): string {
  const label = track.label.trim()
  if (label) return label
  if (track.sourceIndex !== null) return `Дорожка ${track.sourceIndex + 1}`
  return 'Загруженная дорожка'
}
